import http from './http';

class dateService {
    getBlockedDate(params) {
        return http.get('/blocked-days', { params });
    }

    blockDate(payload) {
        return http.post('/blocked-days/block', payload);
    }

    unblockDate(payload) {
        return http.post('/blocked-days/unblock', payload);
    }
}

export default new dateService(); 
